module.exports = __webpack_public_path__ + "static/media/githubLogo.276cd6f1.svg";